import { useContext } from "react";
import { AppContext } from "../App";
import {
  MdClose,
  MdHome,
  MdOutlineArrowOutward,
  MdOutlineCalendarMonth,
  MdOutlinePhoneInTalk,
  MdOutlineSpaceDashboard,
  MdOutlineBusinessCenter, // New icon for Careers
  MdOutlineMedicalServices, // New icon for Services
  MdOutlineCorporateFare, // New icon for About Us (Hospital/Organization)
} from "react-icons/md";
import { hospitalInfo } from "../content/hospitalContent";
import logo from "../assets/logo.png";
import { FaKitMedical } from "react-icons/fa6";

export default function SideBar() {
  const appContext = useContext(AppContext);

  function closeSideBar() {
    appContext.closeSideBar();
  }

  function goTo(item) {
    appContext.navTo({ item });
    closeSideBar();
  }

  const items = [
    { key: "home", label: "Home", icon: <MdHome size={18} /> },
    { key: "about_us", label: "About", icon: <MdOutlineCorporateFare size={18} /> },
    { key: "careers", label: "Careers", icon: <MdOutlineBusinessCenter size={18} /> },
    { key: "clinicalServices", label: "Services", icon: <MdOutlineMedicalServices size={18} /> },
    { key: "contact_us", label: "Contact", icon: <MdOutlinePhoneInTalk size={18} /> },
  ];

  const quickLinks = [
    {
      href: hospitalInfo.scheduleUrl,
      label: "Schedule",
      description: "Book a consultation online.",
      icon: <MdOutlineCalendarMonth size={20} />,
    },
    {
      href: hospitalInfo.staffUrl,
      label: "Staff Portal",
      description: "Secure access for hospital teams.",
      icon: <MdOutlineSpaceDashboard size={20} />,
    },
    {
      href: hospitalInfo.patientUrl,
      label: "Patient Portal",
      description: "Track Individual Patient Records.",
      icon: <FaKitMedical size={20} />,
    },
  ];

  const activeNavItem = appContext.navItem || "home";

  return (
    <aside className="SideBar" data-open={appContext.isSideBarOpen} aria-label="Sidebar navigation">
      <div className="body mNoScrollBar side-modern-body">
        <div className="side-modern-head">
          <button type="button" className="side-modern-close" onClick={appContext.closeSideBar} aria-label="Close menu">
            <MdClose size={24} />
          </button>
        </div>

        <div className="text-center my-5">
          <img src={logo} width={100} alt={`${hospitalInfo.shortName} logo`} />
        </div>

        <div className="side-modern-section">
          <nav className="side-modern-nav" aria-label="Main">
            {items.map((item) => (
              <button
                key={item.key}
                type="button"
                className="side-modern-item"
                onClick={() => goTo(item.key)}
                data-active={activeNavItem === item.key}
              >
                <span className="side-modern-item-icon" aria-hidden="true">
                  {item.icon}
                </span>
                <span className="side-modern-item-label">{item.label}</span>
              </button>
            ))}
          </nav>
        </div>

        <div className="side-modern-section">
          <p className="side-modern-section-label">Quick Access</p>
          <div className="side-modern-links">
            {quickLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                target="_blank"
                rel="noreferrer"
                className="side-modern-link"
                onClick={closeSideBar}
              >
                <span className="side-modern-link-icon" aria-hidden="true">
                  {link.icon}
                </span>
                <span className="side-modern-link-copy">
                  <span className="side-modern-link-title">{link.label}</span>
                  <span className="side-modern-link-text">{link.description}</span>
                </span>
                <span className="side-modern-link-arrow" aria-hidden="true">
                  <MdOutlineArrowOutward size={18} />
                </span>
              </a>
            ))}
          </div>
        </div>

      </div>
    </aside>
  );
}